import script from "./MemberSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberSignature.vue?vue&type=script&setup=true&lang=js"

import "./MemberSignature.vue?vue&type=style&index=0&id=0dd25970&lang=stylus&scoped=true"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd25970"]])

export default __exports__